module.exports = __webpack_public_path__ + "eb318adbf0913f04f53e30ed6068cec8.png";